define('../app/fukit/behavior/single.selected.child.view.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var SingleSelectedChildViewBehavior = Mn.Behavior.extend({
    defaults: {
      // the option name that determines if a view is selected
      optionName: 'active',
    },

    onAddChild: function(childView) {
      this.bindChildViewEvents(childView);
    },

    onRemoveChild: function(childView) {
      this.stopListening(this.getChildView(childView));
    },

    bindChildViewEvents: function(view) {
      view = this.getChildView(view);
      if (!view) {
        return;
      }
      this.listenTo(view, 'change:' + this.getOption('optionName'), function() {
        this.checkIfSelected(view);
      });
      this.checkIfSelected(view);
    },

    checkIfSelected: function(view) {
      if (view.getOption(this.getOption('optionName'))) {
        this.unselectOtherViews(view);
      }
    },

    unselectOtherViews: function(selectedView) {
      this.view.children.each(function(childView) {
        childView = this.getChildView(childView);
        if (childView && childView !== selectedView) {
          childView[this.getOption('optionName')] = false;
        }
      }, this);
    },

    getChildView: function(view) {
      return view;
    },
  });

  module.exports = SingleSelectedChildViewBehavior;
});

